import Node from './node';

export default class ShowAllText extends Node {
  clone() {
    return new ShowAllText(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
